export function capitaliseFirstLetter(word: string): string {
  if (word.length === 0) {
    return word;
  }
  const firstChar = word.charAt(0);
  if (!/^[A-Za-z]$/.test(firstChar)) {
    return word;
  }
  return firstChar.toUpperCase() + word.slice(1);
}
